import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ViewLoginComponent } from './view-login/view-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { SearchFreelancersComponent } from './search-freelancers/search-freelancers.component';
import { CreateRequisitionComponent } from './create-requisition/create-requisition.component';
import { ListRequisitionComponent } from './list-requisition/list-requisition.component';
import { ListQaComponent } from './list-qa/list-qa.component';
import { ViewRequisitionComponent } from './view-requisition/view-requisition.component';

// Route Configuration
export const routes: Routes = [
    { path: 'login', component: ViewLoginComponent },
    { path: 'login/:token', component: ViewLoginComponent },
    { path: 'createrequisition', component: CreateRequisitionComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
    { path: 'recovery', component: RecoveryPasswordComponent },
    { path: 'viewnotification', component: ViewNotificationComponent, canActivate: [AuthGuardService]},
    { path: 'listfreelancers', component: SearchFreelancersComponent, canActivate: [AuthGuardService] },
    { path: 'listqa', component: ListQaComponent, canActivate: [AuthGuardService] },
    { path: 'listrequisition', component: ListRequisitionComponent, canActivate: [AuthGuardService] },
    { path: 'viewrequisition/:id', component: ViewRequisitionComponent, canActivate: [AuthGuardService] },
    { path: 'viewcontract/:id', component: ListRequisitionComponent, canActivate: [AuthGuardService] },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/app.routes.ts